// extracted by mini-css-extract-plugin
export default {"addGramma":"Add_addGramma__lqbhD","addForm":"Add_addForm__8ddoB","formList":"Add_formList__WdH97"};